import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from 'modules/theme';
import { Alert } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { BarItems } from 'modules/theme';
import {
  DataWrapperClass,
  InsightWrapper,
} from '../styles';
import { PerPage } from 'helpers/system-config';
import {
  ModalTrigger,
  Button,
  Table,
  Tip,
  DataWithLoader,
  ControlLabel,
  ReportPagination,
  Spinner,
  CommonFilter,
  ReportingDropdownMenu
} from 'modules/theme';
import { modalType } from '../../../../helpers/dotenv';
import { WrapperData } from 'modules/theme';
import { ManageColumns } from 'modules/theme';
var uuid = require('uuid');
export class REPORT extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `Inbound Missed`;
    this.moduleUrl = `voice-cdr-report/list`;
    let selectedColumList = [];
    this.state = {
      isActive: false,
      listData: [],
      listField: [],
      configList: [],
      loading: false,
      showHide: false,
      modalType: modalType,
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      search: '',
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      Filters: {},
      selectedFilter: {},
      assetsUrl: "",
      // isToggle: false
      columnList: [],
      selectedColumList: selectedColumList,
      customerColumn: {},
      showColumn: false,
      isDownload: false,
      user: [],
      // stickyAgent: [],
    };
    this.bindThis();
  }
  bindThis() {
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.getReportName = this.getReportName.bind(this);
    this.getData = this.getData.bind(this);
    this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.open = this.open.bind(this);
    this.handleModalShowColumn = this.handleModalShowColumn.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.onCustomColumnClick = this.onCustomColumnClick.bind(this);
  }
  componentDidMount() {
    this.getList();
  }

  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }

  openModal() {
    this.setState({ showHide: true });
  }

  closeModal() {
    this.setState({ showHide: false });
  }

  getReportName() {
    return 'default';
  }

  handleModalShowColumn() {
    this.setState({ showColumn: !this.state.showColumn });
  }

  getSelectedColumnNames() {
    return this.state.selectedColumList;
  }

  downloadReport(page = 1, perPage = '', filter = '') {
    var that = this;
    // this.setState({ loading: true });
    this.setState({ isDownload: true });

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;

    let tData = {
      // limit: perPage,
      page_no: page,
      orderBy: '',
      order: '',
      type: 'voice',
      subType: 'missedCall',
      listConfig: this.state.customerColumn || {},
      ...filter
    }
    this.mAPI.sendPostAPI(
      `voice-cdr-report/export/reports`,
      tData,
      data => {
        this.setState({ isDownload: false });
        if (data.status === 'pending') {
          Alert.success(`You can download Report from Import & Export...`);
        } else {
          this.mAPI.downloadUrl(data.fileurl);
          let a = document.createElement('a');
          a.href = data.fileurl;
          a.download = data.csvfileName;
          a.click();
        }

      },
      (error, data) => {
        this.setState({ isDownload: false });
        Alert.error('Error');
      }
    );
  }

  columnProcess(columnList) {
    let result = {
      selected: [],
      total: [],
    }
    if (columnList) {
      columnList.map((column, key) => {
        key = column && column.varibleName ? column.varibleName : key;
        if (key) {
          let field = { "name": key, _id: uuid.v4(), checked: column.isDefault ? true : false };
          result.total.push(field)
          if (column.isDefault) {
            result.selected.push(key)
          }
        }
      })
    }
    return result;
  }

  getData(data) {
    let selectedUser = [];
    // let selectedStickyAgent = [];
    if (data.selectedUser && data.selectedUser.length > 0) {
      data.selectedUser.map((element) => {
        if (element.value) {
          selectedUser.push(element.value);
        }
      })
    }
    // if (data.selectedStickyAgent && data.selectedStickyAgent.length > 0) {
    //   data.selectedStickyAgent.map((element) => {
    //     if (element.value) {
    //       selectedStickyAgent.push(element.value);
    //     }
    //   })
    // }
    let filter = {
      "sendStartTime": data.startDate || "",
      "sendEndTime": data.endDate || "",
      "timezone": data.timezone || {},
      "source": data.fromSelector || "",
      "to": data.toSelector || "",
      "freeTextSearch": data.freeTextSearch || "",
      "agentId": selectedUser,
      // "stickyAgentId": selectedStickyAgent,
    }

    let tempData = {};

    for (let item in data) {
      if (Array.isArray(data[item])) {
        if (item === "selectedUser") {
          tempData = {
            ...tempData,
            agentId: selectedUser
          };
        } else {
          tempData = {
            ...tempData,
            [item]: data[item].map((element) => element.value || element),
          };
        }
      } else {
        if (item === "startDate") {
          tempData = {
            ...tempData,
            sendStartTime: data[item] || "",
          }
        } else if (item === "endDate") {
          tempData = {
            ...tempData,
            sendEndTime: data[item] || "",
          }
        } else if (item === "fromSelector") {
          tempData = {
            ...tempData,
            source: data[item] || "",
          }
        } else if (item === "toSelector") {
          tempData = {
            ...tempData,
            to: data[item] || "",
          }
        } else {
          tempData = {
            ...tempData,
            [item]: data[item],
          }
        }
      }
    }

    this.setState({ "Filters": filter, "currentPage": 1 })
    this.getList(1, this.state.perPageCount, filter)
    // this.downloadReport(1, this.state.perPageCount, filter)
  }

  getList(page = 1, perPage = '', filter = '') {
    var that = this;
    this.setState({ loading: true });

    filter = filter || {};
    perPage = perPage || this.state.perPageCount;
    let tData = {
      limit: perPage,
      page_no: page,
      orderBy: '',
      order: '',
      type: 'voice',
      subType: 'missedCall',
      listConfig: this.state.customerColumn || {},
      ...filter
    };
    this.mAPI.sendPostAPI(
      this.moduleUrl,
      tData,
      data => {
        that.setState({ loading: false });
        if (data && data.data) {
          let result = this.columnProcess(data.configList);
          that.setState({
            assetsUrl: data.assetsUrl,
            listData: data.data,
            listField: data.configList,
            total: data.count || 0,
            SelectedList: [],
            selectedColumList: result.selected,
            columnList: result.total
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        that.setState({ loading: false });
        Alert.error('Error');
      }
    );
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map(listData => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter(e => e.selected)
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map(user => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter(e => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter(e => e.selected)
    });
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getList(page, this.state.perPageCount, this.state.Filters);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.Filters);
  }

  remove(array, key, value) {
    const index = array.findIndex(obj => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  renderCharts() {
    return null;
  }

  onChange() { }

  onSingleChange(e, company) { }

  renderContent() {
    const { brands, history, queryParams } = this.props;
    return (
      <InsightWrapper>
        <CommonFilter
          filterList={["renderTo", "renderFrom", "renderStickyAgent", "renderTeam", "renderMissedReason", "renderTimezones"]}
          getSelectedColumnNames={this.getSelectedColumnNames}
          getData={this.getData}
          history={history}
          brands={[]}
          queryParams={[]}
          selectedFilter={this.state.selectedFilter}
          setFilter={this.setFilter}
          updateFilter={this.updateFilter}
          UserList={this.state.user}
        // StickyAgentList={this.state.stickyAgent}
        />
        {this.renderCharts()}
      </InsightWrapper>
    );
  }

  onCustomColumnClick(columnsConfig) {
    let _this = this;
    let customerColumn = {};
    if (columnsConfig) {
      columnsConfig.map((field) => {
        if (field.checked) {
          const result = _this.state.listField.filter(el => el.varibleName == field.name);
          if (result && result[0]) {
            let column = Object.assign({}, result[0]);
            column.lable = field.label || field.name;
            column.isDefault = field.isDefault;
            column.varibleName = field.label || field.name;
            customerColumn[column.varibleName] = column
          }
        }
      })
    }
    this.setState({ currentPage: 1 });
    this.setState({ "customerColumn": customerColumn, showHide: false, currentPage: 1 }, () => {
      _this.getList(1, _this.state.perPageCount, _this.state.Filters);
    });
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __('Reporting'), link: '/reporting' },
      { title: __('Missed'), link: '/reporting/missed' }
    ];

    let _this = this;
    const mainContent = (
      <div>
        <Table bordered hover>
          <thead>
            <tr>
              {this.state.listField.map(column => {
                return column.isDefault === true ? (<th>{column.label}</th>) : "";
              }
              )}
            </tr>
          </thead>
          <tbody id="Report">
            {_this.state.listData.map(tData => {
              return (
                <tr >
                  {
                    _this.state.listField.map(column => {
                      if (column.isDefault === true) {
                        let result = tData[column.varibleName];
                        if (typeof result != "string" && typeof result != "number") {
                          if (typeof result == "object") {
                            try {
                              result = JSON.stringify(result);
                            } catch (error) {

                            }
                          } else if (typeof result == "boolean") {
                            result = result == true ? 'True' : 'False'
                          } else {
                            result = "-";
                          }
                        }
                        return (
                          <td style={{ "overflow": "hidden", "textOverflow": "ellipsis", "maxWidth": "186px" }} >
                            <Tip text={result} >
                              <span>{result}</span>
                            </Tip>
                          </td>
                        )
                      } else {
                        return "";
                      }
                    })
                  }
                </tr>
              )
            })}
          </tbody>
        </Table>
        {/* </Row> */}
      </div>
    );

    const editColumns = (
      <Button btnStyle="simple" size="small">
        Edit columns
      </Button>
    );

    const actionBarRight = (
      <BarItems>
        <ModalTrigger
          title="Choose which column you see"
          trigger={editColumns}
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          modalType={this.state.modalType}
        >
          <ManageColumns
            contentType="cdrReport"
            config={this.state.selectedColumList}
            save={this.onCustomColumnClick}
            closeModal={this.closeModal}
            fields={this.state.columnList}
          />
        </ModalTrigger>

        <Button
          btnStyle="filter"
          size="small"
          onClick={() => this.open()}
        >
          <img src="/images/filter.png" style={{ width: '15px', marginRight: '5px' }} />Filters
        </Button>
        {this.state.total === 0 ? <Button
          btnStyle="default"
          size="small"
          disabled="true"
          style={{ padding: '9px 12px', width: '94px' }}
          // onClick={this.downloadReport}
          onClick={() =>
            this.downloadReport(1, "", this.state.Filters)
          }
        >
          {this.state.isDownload ? (
            <Spinner style={{ height: '2px', width: '2px', marginTop: '-15px', padding: '10px', marginBottom: '10px' }} />
          ) : (
            'Download'
          )}
        </Button> : <Button
          btnStyle="default"
          size="small"
          style={{ padding: '9px 12px', width: '94px' }}
          // onClick={this.downloadReport}
          onClick={() =>
            this.downloadReport(1, "", this.state.Filters)
          }
        >
          {this.state.isDownload ? (
            <Spinner style={{ height: '2px', width: '2px', marginTop: '-15px', padding: '10px', marginBottom: '10px' }} />
          ) : (
            'Download'
          )}
        </Button>}
      </BarItems>
    );

    return (
      <div>
        <DataWrapperClass>

          {this.state.isActive && <WrapperData content={this.renderContent()} overflow={true} />}

          <WrapperData
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={<ControlLabel>{this.moduleName}</ControlLabel>}
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div>
                    {/*  <ControlLabel>{`${this.moduleName} (${this.state.total || 0})`}</ControlLabel> */}

                  </div>
                }
                right={actionBarRight}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<ReportingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText=""
                  emptyImage="/images/emptyimg.png"
                />
              </div>

              // const filterList = (
              //   <QuestionsContainer style={{ marginRight: '20px' }}>
              //     <Wrapper.Sidebar>
              //       <Section>
              //         <Header uppercase>Filters</Header>
              //         <SidebarList>
              //           {this.state.Filters &&
              //             this.state.Filters.map((filter, index) => {
              //               return (
              //                 <li key={filter._id}>
              //                   <a
              //                     className={
              //                       this.state.selectedFilter &&
              //                         this.state.selectedFilter._id === filter._id
              //                         ? 'active'
              //                         : ''
              //                     }
              //                     onClick={e => this.handleOnClick(filter._id)}
              //                   >
              //                     {filter.filterName}
              //                     <Button
              //                       btnStyle="link"
              //                       onClick={e =>
              //                         confirm().then(e => {
              //                           this.deletevalue(filter._id);
              //                         })
              //                       }
              //                     >
              //                       <Tip text="Delete Question">
              //                         <Icon icon="cancel-1" />
              //                       </Tip>
              //                     </Button>
              //                   </a>
              //                 </li>
              //               );
              //             })}
              //         </SidebarList>
              //       </Section>
              //     </Wrapper.Sidebar>
              //   </QuestionsContainer>
              // );
            }
          />
        </DataWrapperClass>
        {/* <DataWrapperClass>
          <Wrapper
            leftSidebar={filterList}
            showLeftSideBar={this.state.isToggle}
            content={this.renderContent()}
          />
        </DataWrapperClass> */}
      </div>
    );
  }
}

REPORT.contextTypes = {
  __: PropTypes.func
};

export default REPORT;



// WEBPACK FOOTER //
// src/modules/screens/reporting/CommonReport/index.js